<template>
    <tr :is-selected="isSelected" class="text-gray-700" :class="rowClass"
        @click="openRowDetails"
        @mouseenter="handleRowEnter(0)"
        @mouseleave="handleRowLeave"
    >
        <td class="border-r border-b border-gray-200 align-top" :style="generalInfoOuterCellStyle">
            <div :style="generalInfoInnerCellStyle" class="px-3 py-1.5 flex flex-col">
                <div class="flex flex-col ">
                    <div class="flex w-full justify-between">
                        <div class="pl-0 text-base text-gray-900 truncate">
                            {{ emailTemplateName }}
                        </div>
                    </div>
                    <div class="whitespace-prewrap flex flex-wrap gap-1 pb-2 justify-between tracking-wide items-center">
                        <div class="font-semibold text-gray-700 truncate">
                            {{ clientName }} ({{ templateCreationDate }})
                        </div>
                    </div>
                    <!-- <div class="flex w-full justify-between  pb-2">
                    <div class="whitespace-nowrap font-semibold tracking-wide  text-gray-800 pr-0">
                        BCC:
                    </div>
                    <div class="border-b-2 border-dotted border-gray-400 flex-grow mb-2 mx-1"></div>
                    <div class="pl-0">
                        {{ mailBCC }}
                    </div>
                </div>
                <div class="flex w-full justify-between">
                    <div class="whitespace-nowrap font-semibold tracking-wide  text-gray-800 pr-0">
                        From:
                    </div>
                    <div class="border-b-2 border-dotted border-gray-400 flex-grow mb-2 mx-1"></div>
                    <div class="pl-0">
                        {{ mailFrom }}
                    </div>
                </div> -->
                <div class="flex w-full justify-start space-x-2 items-center pb-2">
                    <div class="whitespace-nowrap font-semibold tracking-wide  text-gray-800 pr-0">
                        Subject:
                    </div>
                    <!-- <div class="border-b-2 border-dotted border-gray-400 flex-grow mb-2 mx-1"></div> -->
                    <div class="pl-0 text-gray-700 truncate">
                        {{ emailSubject }}
                    </div>
                </div>
                <!-- <div class="flex w-full justify-between ">
                    <div class="whitespace-nowrap font-semibold tracking-wide  text-gray-800 pr-0">
                        Created:
                    </div>
                    <div class="border-b-2 border-dotted border-gray-400 flex-grow mb-2 mx-1"></div>
                    <div class="pl-0">
                    {{ templateCreationDate }}
                    </div>
                </div>
                <div class="flex w-full justify-between ">
                    <div class="whitespace-nowrap font-semibold tracking-wide  text-gray-800 pr-0">
                        Last Updated:
                    </div>
                    <div class="border-b-2 border-dotted border-gray-400 flex-grow mb-2 mx-1"></div>
                    <div class="pl-0">
                    {{ templateUpdatedDate }}
                    </div>
                </div> -->
                </div>
            </div>
        </td>
    </tr>
</template>

<script setup>
import { ref, defineProps, defineEmits, watch, computed, onMounted } from 'vue';
import ExpandSVG from '../svg-components/ExpandSVG.vue';
import LoadingButton from '../base-components/LoadingButton.vue';
import TableRow from '../base-components/TableRow.vue';
import Grid3x2SVG from '../svg-components/Grid3x2SVG.vue';
import ChevronDownMiniSVG from '../svg-components/ChevronDownMiniSVG.vue';
import ChevronUpMiniSVG from '../svg-components/ChevronUpMiniSVG.vue';
import { formatDateMonthAndYear } from '@/composables/formatDate';

const props = defineProps([
    'emailTemplate', 
    'selectAll', 
    'expandAll',
    'clearedSelectedResults', 
    'crmStatusOptions', 
    'crmNextActionOptions',
    'resetToPreviousCRMAction',
    'actionButtonResetId',
    'openRow',
])

const emit = defineEmits([
    'open-row-details', 
    'select-row', 
    'deselect-row', 
    'update-crm-status',
    'perform-row-action',
])

const isSelected = ref(props.selectAll)
const expandedRow = ref(false)
const rowHover = ref(false)
const canSetRowHover = ref(false)
const canExpandRow = ref(true)

const rowBoundary = ref(null)

const initialRowHeight = ref(null)

// onMounted(() => {
//     initialRowHeight.value = Math.round(rowBoundary.value.getBoundingClientRect().bottom - rowBoundary.value.getBoundingClientRect().top).toString()
// })

watch(() => props.selectAll, () => {
    isSelected.value = props.selectAll
    if(props.selectAll) {
        emit('select-row',props.emailTemplate)
    } else if (!props.selectAll) {
        emit('deselect-row', props.emailTemplate)
    }
})

watch(() => props.expandAll, () => {
    // console.log('watch expandAll', props.expandAll)
    if(props.expandAll == 'expand') {
        expandRow()
    } else if (props.expandAll == 'collapse') {
        collapseRow()
    }
})

watch(() => props.clearedSelectedResults, () => {
    // console.log("clearedSelectedResults changed")
    isSelected.value = false
})

const rowClass = computed(() => {
    return props.openRow && props.openRow.id == props.emailTemplate.id ? 'bg-indigo-100 hover:bg-indigo-100' : 'odd:bg-white even:bg-gray-100 hover:bg-indigo-50'
})

const actionDelay = computed(() => {
    if(expandedRow.value || rowHover.value) {
        return 150
    } else {
        return 1250
    }
})

const rowActionsOuterCellStyle = computed(() => {
    if(rowHover.value) {
        return ''
    } else {
        return ''
    }

})

const rowActionsInnerCellStyle = computed(() => {
    return ''
})

const generalInfoOuterCellStyle = computed(() => {
    return ''
})

const generalInfoInnerCellStyle = computed(() => {
    return ''
})


const addressInfoOuterCellStyle = computed(() => {
    let outerCellStyle = ''
    if(expandedRow.value) {
        outerCellStyle += 'height: 100%; '
    } else {
        outerCellStyle += `height: ${initialRowHeight.value}px; `
    }
    return outerCellStyle
})

const addessInfoInnerCellStyle = computed(() => {
    let innerCellStyle = ''
    innerCellStyle += 'padding: 28px 12px 6px 12px;'
    return innerCellStyle
})

const templateInfoOuterCellStyle = computed(() => {
    let outerCellStyle = ''
    if(expandedRow.value) {
        outerCellStyle += 'height: 100%; '
    } else {
        outerCellStyle += `height: ${initialRowHeight.value}px; `
    }
    return outerCellStyle
})

const templateInfoInnerCellStyle = computed(() => {
    let innerCellStyle = ''
    innerCellStyle += 'padding: 28px 12px 6px 12px;'
    return innerCellStyle
})

// const campaignOuterCellStyle = computed(() => {
//     let outerCellStyle = ''
//     if(expandedRow.value) {
//         outerCellStyle += 'height: 100%; '
//     } else {
//         outerCellStyle += `height: ${initialRowHeight.value}px; `
//     }
//     if(visibleCampaignActions.value) {
//         outerCellStyle += `border-top: 3px solid #9EA0BD; border-right: 3px solid #9EA0BD; border-bottom: none; border-left: 3px solid #9EA0BD; border-top-left-radius: 8px; border-top-right-radius: 8px;`
//     }
//     return outerCellStyle
// })

// const campaignInnerCellStyle = computed(() => {
//     let innerCellStyle = ''
//     if(visibleCampaignActions.value) {
//         innerCellStyle += 'padding: 25px 9px 3px 9px;'
//     } else {
//         innerCellStyle += 'padding: 28px 12px 6px 12px;'
//     }
//     return innerCellStyle
// })

const clientName = computed(() => {
    return props.emailTemplate.client ? props.emailTemplate.client.client_name : '';
})

const emailTemplateName = computed(() => {
    return props.emailTemplate.email_template_name ? props.emailTemplate.email_template_name : '';
})

const emailTemplateStatus = computed(() => {
    return props.emailTemplate.status ? props.emailTemplate.status : '';
})

const mailFrom = computed(() => {
    return props.emailTemplate.email_from_new ? props.emailTemplate.email_from_new.email_address : '';
})

const mailBCC = computed(() => {
    return props.emailTemplate.email_bcc ? props.emailTemplate.email_bcc : '';
})

const emailSubject = computed(() => {
    return props.emailTemplate.subject ? props.emailTemplate.subject : '';
})

const templateCreationDate = computed(() => {
    return props.emailTemplate.created_at ? formatDateMonthAndYear(props.emailTemplate.created_at) : '';
})

// const templateUpdatedDate = computed(() => {
//        return props.emailTemplate.updated_at ? formatDate(props.emailTemplate.updated_at) : ''; 
// })

// const emailBody = computed(() => {
//     return props.emailTemplate.email_body ? props.emailTemplate.email_body : '';
// })

function expandRow() {
    expandedRow.value = true
}

function collapseRow() {
    expandedRow.value = false
}

function toggleExpandRow() {
    // console.log('toggleExpandRow', canExpandRow.value)
    if(canExpandRow.value) {
        if(expandedRow.value) {
            collapseRow()
        } else {
            expandRow()
        }
    }
}

function handleRowEnter(delay) {
    canSetRowHover.value = true
    if(delay) {
        setTimeout(() => {
            if(canSetRowHover.value) {
                rowHover.value = true
            }
        }, delay)
    } else {
        expandRow()
    }
}

function handleRowLeave() {
    canSetRowHover.value = false
    rowHover.value = false
}

function toggleSelected() {
    if(isSelected.value) {
        isSelected.value = false
        emit('deselect-row', props.company)
    } else {
        isSelected.value = true
        emit('select-row', props.company)
    }
}

function performRowAction(actionData) {
    actionData.emailTemplate = props.emailTemplate
    // console.log('performRowAction', actionData)
    emit('perform-row-action', actionData)
}

function openRowDetails() {
    emit('open-row-details', props.emailTemplate)
}
</script>